import { render } from "./Spinner.vue?vue&type=template&id=4a1f0e92&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=4a1f0e92&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1f0e92"]])

export default __exports__